module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper pt-header65"
  }, [_c('header', {
    staticClass: "gheader -white gheader-fix"
  }, [_c('div', {
    staticClass: "gheader__link-back"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.goTop()
      }
    }
  }, [_vm._v("戻る")])])]), _c('div', {
    staticClass: "bg04 heyheyho"
  }, [_vm._m(0), _vm._m(1), _c('div', {
    staticClass: "heyheyho__select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectYear),
      expression: "selectYear"
    }],
    staticClass: "select01 -default-style heyheyho__select__box",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectYear = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.magazineGet(_vm.selectYear)
      }]
    }
  }, _vm._l((_vm.years), function(year) {
    return _c('option', {
      domProps: {
        "value": year
      }
    }, [_vm._v(_vm._s(year) + "年")])
  }), 0)]), (_vm.magazineCallbackFlag) ? _c('div', {
    staticClass: "heyheyho__list"
  }, _vm._l((_vm.magazines), function(magazine) {
    return _c('div', {
      staticClass: "heyheyho__list__item"
    }, [_c('h3', [_vm._v(_vm._s(magazine.attributes['magazine-ym-format']) + "号")]), _c('a', {
      staticClass: "heyheyho__list__item__wrap mt10"
    }, [_c('div', {
      staticClass: "heyheyho__list__item__wrap__content"
    }, [_c('img', {
      attrs: {
        "src": magazine.attributes['magazine-picture-path'] + '?token=' + _vm.authToken + '&timestamp=' + _vm.timeStamp
      },
      on: {
        "click": function($event) {
          _vm.goMagazinePdf(magazine.attributes['magazine-pdf-path'])
        }
      }
    })])])])
  }), 0) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "heyheyho__title"
  }, [_c('h2', [_c('img', {
    attrs: {
      "src": require("../images/img_title_12.png"),
      "alt": "社内報"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "heyheyho__title__bottom"
  }, [_c('p', [_vm._v("社内報が見れるニャン♪")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-91858022!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/magazine-list.pug
// module id = 1447
// module chunks = 1